import forgotCredentialsModule from "../forgotCredentialsModule.js";
import { EnvironmentUrls, MetaDataValues, AccountIntegrityChallengeService } from "Roblox";

function forgotCredentialsController($scope, $window, $uibModal, modalService, httpService, urlService, regexService, phoneService, hybridService, errorMessageService, forgotCredentialsService, phoneConstants, captchaV2Constants, forgotCredentialsConstants, languageResource) {
    "ngInject";

    var passwordResetErrorMap = {};
    passwordResetErrorMap[forgotCredentialsConstants.passwordErrorCodes.flooded] = languageResource.get("MessageFloodCheckedError");
    passwordResetErrorMap[forgotCredentialsConstants.passwordErrorCodes.invalidTarget] = languageResource.get("MessageAccountNotFoundByPhone");
    var passwordResetErrorMapper = errorMessageService.createErrorMapper(passwordResetErrorMap, languageResource.get("Message.DefaultError"));

    $scope.layout = {
        isEmailSelected: true,
        isPhoneSelected: false,
        isSecurityNotificationPage: false,
    };

    $scope.layout.isSecurityNotificationPage = MetaDataValues.getPageName().toLowerCase() === forgotCredentialsConstants.pages.securityNotification.toLowerCase();

    $scope.data = {};
    $scope.forms = {
        emailForm: {}
    };

    $scope.captchaActionTypes = captchaV2Constants.captchaActionTypes;
    $scope.captcha = forgotCredentialsService.captcha;

    // Triggered when the "Use phone for recovery" button is clicked.
    $scope.usePhoneNumberClicked = function() {
        sendEvent(forgotCredentialsConstants.events.formInteractionEventType,
            forgotCredentialsConstants.events.usePhoneToResetBtn);
        $scope.changeInputToPhone();
    }

    // Triggered when the "Use email for recovery" button is clicked.
    $scope.useEmailClicked = function() {
        sendEvent(forgotCredentialsConstants.events.formInteractionEventType,
            forgotCredentialsConstants.events.useEmailToResetBtn);
        $scope.changeInputToEmail();
    }

    $scope.changeInputToPhone = function () {
        $scope.layout.isEmailSelected = false;
        $scope.layout.isPhoneSelected = true;
        $scope.clearInputErrors();
    }

    $scope.changeInputToEmail = function () {
        $scope.layout.isEmailSelected = true;
        $scope.layout.isPhoneSelected = false;
        $scope.clearInputErrors();
    }

    $scope.clearInputErrors = function () {
        $scope.clearEmailError();
        $scope.clearPhoneError();
    }

    $scope.getPhonePrefix = function (value) {
        if (!value) {
            return "";
        }

        return phoneConstants.phonePrefixCharacter + value.prefix;
    }

    $scope.getPhonePrefixes = function (apiProxyDomain) {
        // somehow it's using \WebApps\Roblox.AccountSettings.WebApp\Roblox.AccountSettings.WebApp\js\angular\phoneValidation\services\phoneService.js
        phoneService.getAllPhonePrefixes(apiProxyDomain)
            .then(function success(data) {
                $scope.data.phonePrefixes = data;

                // set default
                if ($scope.data.phonePrefixes) {
                    $scope.data.phonePrefix = $scope.data.phonePrefixes[0];
                }
            });
    }

    $scope.getInstructions = function () {
        if ($scope.layout.isEmailSelected) {
            return languageResource.get("Description.EmailToRecoverAccount");
        }
        return languageResource.get("Description.PhoneToRecoverAccount");
    }

    $scope.getHeading = function () {
        return languageResource.get("Heading.RecoverRobloxAccount");
    }

    $scope.clearEmailError = function () {
        $scope.layout.emailError = null;
    }

    $scope.clearPhoneError = function () {
        $scope.layout.phoneError = null;
    }

    $scope.hasEmailError = function () {
        return $scope.isEmailInvalid() || $scope.layout.emailError;
    }

    $scope.hasPhoneError = function () {
        return $scope.isPhoneInvalid() || $scope.layout.phoneError;
    }

    $scope.isEmailInvalid = function () {
        return !$scope.layout.emailError && !$scope.forms.emailForm.email.$valid;
    }

    $scope.isPhoneInvalid = function () {
        return !$scope.layout.phoneError && $scope.data.phone
            && !$scope.forms.phoneForm.phone.$valid;
    }

    $scope.submitEmail = function () {
        if (!$scope.data.email || $scope.forms.emailForm.$invalid) {
            return;
        }

        $scope.clearEmailError();
        $scope.layout.isSubmitBusy = true;
        var email = $scope.data.email;
        $scope.submitEmailForPassword(email);
    }

    $scope.submitPhone = function () {
        if ($scope.forms.phoneForm.$invalid) {
            return;
        }

        $scope.clearPhoneError();
        $scope.layout.isSubmitBusy = true;
        var phone = $scope.data.phone;
        var phonePrefix = $scope.data.phonePrefix;

        if (!phonePrefix) {
            $scope.layout.isSubmitBusy = false;
            return;
        }

        $scope.submitPhoneForPassword(phonePrefix, phone);
    }

    $scope.isSubmitLoading = function () {
        return $scope.layout.isSubmitBusy || $scope.captcha.isActivated;
    }

    $scope.submitEmailForPassword = function (email) {
        sendEvent(forgotCredentialsConstants.events.buttonClickEventType,
            forgotCredentialsConstants.events.forgotPasswordUseEmailBtn);

        forgotCredentialsService.sendResetPasswordForEmail(email)
            .then(function (data) {
                if (!data) {
                    $scope.layout.emailError = languageResource.get("Message.DefaultError");
                    return;
                }

                $scope.showSuccessModal(languageResource.get("Message.EmailSuccessTitle"), languageResource.get("Message.EmailSuccessBody"));
                $scope.data.email = null;
            }, function (result) {
                // Ignore challenge abandons.
                if (AccountIntegrityChallengeService.Generic.ChallengeError.matchAbandoned(result)) {
                    return;
                }
                $scope.layout.emailError = passwordResetErrorMapper.getErrorMessageFromResponse(result);
            })
            .finally(function () {
                $scope.layout.isSubmitBusy = false;
            });
    }

    $scope.submitPhoneForPassword = function (phonePrefix, phone, captchaData) {
        sendEvent(forgotCredentialsConstants.events.buttonClickEventType,
            forgotCredentialsConstants.events.forgotPasswordUsePhoneBtn);

        forgotCredentialsService.sendResetPasswordForPhone(phonePrefix.prefix, phone, phonePrefix.code, captchaData)
            .then(function (data) {
                if (!data) {
                    $scope.layout.phoneError = languageResource.get("Message.DefaultError");
                    return;
                }

                if (data.nonce) {
                    $scope.displayVerificationModal(data.nonce, data.transmissionType, phonePrefix.prefix, phone, phonePrefix.code);
                } else {
                    $scope.layout.phoneError = data.message;
                }
            },
            function (result) {
                // Ignore challenge abandons.
                if (Generic.ChallengeError.matchAbandoned(result)) {
                    return;
                }
                var errorCode = httpService.getPrimaryApiErrorCode(result);
                if (errorCode === forgotCredentialsConstants.passwordErrorCodes.captcha) {
                    $scope.captcha.isActivated = true;
                    $scope.captcha.captchaPassed = function (captchaData) {
                        $scope.submitPhoneForPassword(phonePrefix, phone, captchaData);
                    };
                    $scope.captcha.captchaFailed = function () { $scope.layout.phoneError = languageResource.get("Message.DefaultError"); };
                    var dxBlob, captchaId, jsonData = '';
                    var captchaData = result.errors[0].fieldData;
                    if (captchaData != null) {
                        try {
                            jsonData = JSON.parse(captchaData);
                            dxBlob = jsonData.dxBlob;
                            captchaId = jsonData.unifiedCaptchaId;
                        } catch (e) {
                            // backward compatible with old version that returns string only.
                            dxBlob = captchaData;
                        }
                    }
                    $scope.captchaInputParams = { unifiedCaptchaId: captchaId, dataExchange: dxBlob };
                    return;
                }

                $scope.layout.phoneError = passwordResetErrorMapper.getErrorMessageFromResponse(result);
            }).finally(function () {
                $scope.layout.isSubmitBusy = false;
            });
    }

    $scope.displayVerificationModal = function (nonce, transmissionType, prefix, phone, countryCode) {
        $scope.verifyCodeData = {
            codeLength: $scope.data.codeLength,
            placeholderText: languageResource.get("Placeholder.EnterCode", { codeLength: $scope.data.codeLength }),
            phonePrefix: prefix,
            phone: phone,
            countryCode: countryCode,
            nonce: nonce,
            transmissionType: transmissionType
        };
                
        var modalParams = {
            backdrop: 'static',
            templateUrl: 'verify-code',
            scope: $scope,
            controller: 'verifyCodeController'
        };

        $uibModal.open(modalParams).result
            .then(function (userTicket) {
                var url = urlService.getAbsoluteUrl(forgotCredentialsConstants.urls.resetPassword) + forgotCredentialsConstants.urls.resetPasswordV3Params + userTicket.ticket;
                $window.location.href = url;
            })
            .finally(function () {
                $scope.layout.isSubmitBusy = false;
            });
    }

    $scope.showSuccessModal = function (title, body) {
        var modal = modalService.open({
            titleText: title,
            bodyText: body,
            neutralButtonText: languageResource.get("Action.Ok")
        });

        modal.result.then(function() {}, function () {
            hybridService.close();
        });

        return modal;
    }

    $scope.init = function () {
        forgotCredentialsService.getMetadata()
            .then(function (data) {
                if (!data) {
                    return;
                }

                forgotCredentialsService.setAuthApi(EnvironmentUrls.authApi);
                $scope.getPhonePrefixes(EnvironmentUrls.apiProxyUrl);

                $scope.captcha.returnTokenInSuccessCb = data.isBedev2CaptchaEnabledForPasswordReset;
                $scope.data.codeLength = data.codeLength;
            });

        regexService.getEmailRegex()
            .then(
                function (data) {
                    if (data) {
                        $scope.layout.emailRegex = data.Regex;
                    }
                }
            );
    }

    function sendEvent(eventType, buttonName) {
        if (Roblox.EventStream) {
            Roblox.EventStream.SendEvent(eventType,
                forgotCredentialsConstants.events.recoverCredentialsCtx,
                { btn: buttonName });
        }
    }

    $scope.init();
}

forgotCredentialsModule
    .controller("forgotCredentialsController", forgotCredentialsController);

export default forgotCredentialsController;
